<script setup lang="ts">
const { slug } = defineProps<{
  title: string
  publishDate: Date
  slug: string
  pdfButton?: StoryBlokButton[]
  zipButton?: StoryBlokButton[]
}>()

const detailPagePath = useTrailingSlash(useRuntimeConfig().public.press?.detailPagePath.replace(':slug', slug))
</script>

<template>
  <div class="bg-white border-1 rounded-xl flex flex-col xl:flex-row xl:items-center xl:justify-between p-5 gap-5">
    <NuxtLink :to="detailPagePath" class="flex flex-col xl:flex-row xl:items-center gap-5 overflow-hidden text-left">
      <span class="text-gray-dark min-w-150px">
        {{ useFormatDate(publishDate, 'dd. MMMM yyyy') }}
      </span>
      <b class="xl:truncate">
        {{ title }}
      </b>
    </NuxtLink>
    <div v-if="pdfButton?.length || zipButton?.length" class="flex gap-2 justify-around xl:min-w-300px md:justify-end">
      <StoryblokButton v-if="pdfButton?.length" v-bind="pdfButton[0]" class="border-2 border-primary" />
      <StoryblokButton v-if="zipButton?.length" v-bind="zipButton[0]" class="" />
    </div>
  </div>
</template>
